export const camalize = (str) => {
  return str
    .toLowerCase()
    .replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
};

export const validateEmail = (email) => {
  return email.match(/[^\s@]+@[^\s@]+\.[^\s@]+/gi);
};

export const validateConfirmPassword = (password, confirmPassword) => {
  return password !== confirmPassword;
};
